import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz17 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel18'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel16'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Ratio of Boys and Girls in a Country where people want only boys</h1>
    
    <div class="text">
        <p>In a country, all families want a boy. They keep having babies till a boy is born. What is the expected ratio
            of boys and girls in the country?</p>
        <p>&nbsp;<br/>
            &nbsp;<br/>
            &nbsp;</p>
            <div class="container">
        <p><strong>Solution:</strong><br/>
            Assumptions: Probability of having a boy or girl is same. Also, the probability
            of next kid being a boy doesn’t depend on history.</p>
        <p>The problem can be solved by counting expected number of girls before a baby boy is born.</p>
        <pre>
    Let <strong>NG </strong>be the expected no. of girls before a boy is born <br/>
     <br/>
    Let p be the probability that a child is girl and (1-p) <br/>
    be probability that a child is boy. <br/>
     <br/>
    NG can be written as sum of following infinite series. <br/>
     <br/>
    NG = 0*(1-p) + 1*p*(1-p) + 2*p*p*(1-p) + 3*p*p*p*(1-p) + 4*p*p*p*p*(1-p) +..... <br/>
     <br/>
    Putting p = 1/2 and (1-p) = 1/2 in above formula. <br/>
     <br/>
    NG    = 0*(1/2) + 1*(1/2)<sup>2</sup> + 2*(1/2)<sup>3</sup> + 3*(1/2)<sup>4</sup>  +  4*(1/2)<sup>5</sup> + ... <br/>
    1/2*NG = 0*(1/2)<sup>2</sup> + 1*(1/2)<sup>3</sup> + 2*(1/2)<sup>4</sup> + 3*(1/2)<sup>5</sup>  +  4*(1/2)<sup>6</sup> + ... <br/>
     <br/>
    NG - NG/2 =  1*(1/2)<sup>2</sup> + 1*(1/2)<sup>3</sup> + 1*(1/2)<sup>4</sup> + 1*(1/2)<sup>5</sup>  +  1*(1/2)<sup>6</sup> +  ...<br/>
     <br/>
    Using sum formula of infinite geometrical progression with <br/>
    ratio less than 1 <br/>
    NG/2 = (1/4)/(1-1/2) = 1/2 <br/>
     <br/>
    NG = 1 <br/>
    </pre> <br/>
        <p>So Expected Number of number of girls = 1</p> <br/>
        <p>Since the expected number of girls is 1 and there is always a baby boy, the expected ratio of boys and girls
            is 50:50</p>
        </div>
    </div>
</article>
        </div>
    )
}

export default Puz17
